import { Switch } from "@blueprintjs/core";
import { IWidgetProps } from "decorator-form";

const CheckBoxWidget: React.SFC<IWidgetProps<boolean>> = (props) => {
	const { value, onChange, required, disabled } = props;
	return (
		// why accept string instaed of bool, blueprint?
		<Switch onChange={(event: any) => onChange(event.target.checked)} checked={`${value}` === 'true'} disabled={disabled} required={required}  />
	);
};

export default CheckBoxWidget;



// WEBPACK FOOTER //
// ./src/common/form/widgets/CheckBoxWidget.tsx